import React from 'react';
import { humanizeCount } from 'helpers/humanizeCount';
import PropTypes from 'prop-types';
import { Text } from 'rebass/styled-components';
import { TooltipContain } from '../../companySizeGraph/customTooltip';

const CustomEdgarTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <TooltipContain>
        <Text fontSize="14px" fontWeight="medium">
          {payload[0]?.payload?.name}
        </Text>
        {payload[0]?.payload?.revenue && (
          <Text fontSize="14px" fontWeight="medium">
            Revenue: {humanizeCount(payload[0]?.payload?.revenue)}$
          </Text>
        )}
        {payload[0]?.payload?.netProfits && (
          <Text fontSize="14px" fontWeight="medium">
            Net profit: {humanizeCount(payload[0]?.payload?.netProfits)}$
          </Text>
        )}
        {payload[0]?.payload?.assets && (
          <Text fontSize="14px" fontWeight="medium">
            Assets: {humanizeCount(payload[0]?.payload?.assets)}$
          </Text>
        )}
        {payload[0]?.payload?.grossProfits && (
          <Text fontSize="14px" fontWeight="medium">
            Gross profits: {humanizeCount(payload[0]?.payload?.grossProfits)}$
          </Text>
        )}
        {payload[0]?.payload?.ebitda && (
          <Text fontSize="14px" fontWeight="medium">
            EBITDA: {humanizeCount(payload[0]?.payload?.ebitda)}$
          </Text>
        )}
        {payload[0]?.payload?.basicEps && (
          <Text fontSize="14px" fontWeight="medium">
            Basic Eps: {humanizeCount(payload[0]?.payload?.basicEps)}$
          </Text>
        )}
        {payload[0]?.payload?.totalCapitalization && (
          <Text fontSize="14px" fontWeight="medium">
            Total capitalization: {humanizeCount(payload[0]?.payload?.totalCapitalization)}$
          </Text>
        )}
      </TooltipContain>
    );
  }

  return null;
};

CustomEdgarTooltip.propTypes = {
  payload: PropTypes.array.isRequired,
  active: PropTypes.bool.isRequired,
};

export default CustomEdgarTooltip;
